import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Loader } from '@grupa-pracuj/react-loader';

import OfferTabsContainer from 'src/containers/OfferTabsContainer';
import OffersListingContainer from 'src/containers/OffersListingContainer';

import Pagination from 'src/components/Pagination/PaginationWrapper';
import RecommendationsHeaderContainer from 'src/components/RecommendationsHeaderContainer';

import 'src/containers/PaginationContainer.scss';


class PaginationContainer extends PureComponent {
  render() {
    const { processing, context } = this.props;

    return (
      <div data-test="section-recommendations" styleName="offers">

        <RecommendationsHeaderContainer />

        <OfferTabsContainer />

        <Pagination activeTab={ context }>
          { processing && <div data-test="section-loader" styleName="offers__loader"><Loader /></div> }
          { !processing && <OffersListingContainer /> }
        </Pagination>

        <span styleName="offers__background" />
      </div>
    );
  }
}


PaginationContainer.propTypes = {
  context: PropTypes.string.isRequired,
  processing: PropTypes.bool.isRequired
};

const mapStateToProperties = state => ({
  context: state.contextReducer.context,
  processing: state.offersReducer.processing
});

export default connect(mapStateToProperties)(PaginationContainer);
